// controls/date.js — champ de sélection de date
import React, { useState, useEffect } from "react";
import CommonControls from "./inc/Common";

/**
 * Création d’un champ date conforme JSON Schema draft 2020-12
 */
export function createDateField() {
  return {
    type: "string",
    format: "date",
    title: "Date",
    "x-ui": "date",
    "x-placeholder": "",
    "x-min": "",
    "x-max": "",
    "x-format": "YYYY-MM-DD", // format de sortie
    "x-defaultToday": false,
  };
}

/**
 * Éditeur du champ Date (FieldEditor)
 */
export function EditDateField({ field, onChange }) {
  const [min, setMin] = useState(field["x-min"] || "");
  const [max, setMax] = useState(field["x-max"] || "");
  const [placeholder, setPlaceholder] = useState(field["x-placeholder"] || "");
  const [format, setFormat] = useState(field["x-format"] || "YYYY-MM-DD");
  const [defaultToday, setDefaultToday] = useState(field["x-defaultToday"] || false);

  // 🔄 Synchronisation vers le parent
  useEffect(() => onChange("x-min", min), [min]);
  useEffect(() => onChange("x-max", max), [max]);
  useEffect(() => onChange("x-placeholder", placeholder), [placeholder]);
  useEffect(() => onChange("x-format", format), [format]);
  useEffect(() => onChange("x-defaultToday", defaultToday), [defaultToday]);

  return (
    <>
      <CommonControls field={field} onChange={onChange} />

      {/* ---- Placeholder ---- */}
      <div className="mb-3">
        <label className="form-label">Texte indicatif (placeholder)</label>
        <input
          type="text"
          className="form-control form-control-sm"
          placeholder="ex : Sélectionnez une date"
          value={placeholder}
          onChange={(e) => setPlaceholder(e.target.value)}
        />
      </div>

      {/* ---- Date min / max ---- */}
      <div className="row mb-3">
        <div className="col">
          <label className="form-label">Date minimale</label>
          <input
            type="date"
            className="form-control form-control-sm"
            value={min}
            onChange={(e) => setMin(e.target.value)}
          />
        </div>
        <div className="col">
          <label className="form-label">Date maximale</label>
          <input
            type="date"
            className="form-control form-control-sm"
            value={max}
            onChange={(e) => setMax(e.target.value)}
          />
        </div>
      </div>

      {/* ---- Format ---- */}
      <div className="mb-3">
        <label className="form-label">Format de sortie</label>
        <select
          className="form-select form-select-sm"
          value={format}
          onChange={(e) => setFormat(e.target.value)}
        >
          <option value="YYYY-MM-DD">YYYY-MM-DD (ISO)</option>
          <option value="DD/MM/YYYY">DD/MM/YYYY</option>
          <option value="MM/DD/YYYY">MM/DD/YYYY</option>
        </select>
      </div>

      {/* ---- Valeur par défaut ---- */}
      <div className="form-check mb-3">
        <input
          type="checkbox"
          className="form-check-input"
          id={`defaultToday_${field.id}`}
          checked={defaultToday}
          onChange={(e) => setDefaultToday(e.target.checked)}
        />
        <label className="form-check-label" htmlFor={`defaultToday_${field.id}`}>
          Définir la date du jour par défaut
        </label>
      </div>
    </>
  );
}

/* =========================================================
   🧩 FRONT — rendu du champ Date
   ========================================================= */
export const RenderDateField = ({
  field,
  value,
  onChange,
  className,
  errorMessage    // <--- AJOUT
}) => {
  const placeholder = field["x-placeholder"] || "";
  const min = field["x-min"] || undefined;
  const max = field["x-max"] || undefined;
  const required = field.required || false;
  const defaultToday = field["x-defaultToday"] || false;

  // Si aucune valeur mais defaultToday activé → initialise la date du jour
  const initialValue =
    value ||
    (defaultToday
      ? new Date().toISOString().split("T")[0] // format YYYY-MM-DD
      : "");

  return (
    <div className={`fb-field fb-date ${field["x-bloc-class"] || ""} ${className || ""}`}>

      {/* Label */}
      {field.title && (
        <label className={`form-label ${errorMessage ? "text-danger" : ""}`}>
          {field.title} {required && <span className="text-danger">*</span>}
        </label>
      )}

      {/* Input date */}
      <input
        type="date"
        className={`
          form-control
          ${field["x-control-class"] || ""}
          ${errorMessage ? "is-invalid" : ""}
        `}
        value={initialValue}
        min={min}
        max={max}
        placeholder={placeholder}
        onChange={(e) => onChange?.(e.target.value)}
      />

      {/* Message d’erreur */}
      {errorMessage && (
        <div className="invalid-feedback d-block mt-1">
          {errorMessage}
        </div>
      )}

    </div>
  );
};
